import {
  Stack,
  Link,
  useColorModeValue,
  chakra,
  VisuallyHidden,
} from '@chakra-ui/react';

import { FaLinkedin, FaTwitter, FaGithub, FaLink } from 'react-icons/fa';

import './socialButtons.scss'

const SocialButton = ({
  children,
  label,
}) => {
  return (
  <chakra.button
      bg={useColorModeValue('blackAlpha.100', 'whiteAlpha.100')}
      rounded={'full'}
      w={8}
      h={8}
      cursor={'pointer'}
      display={'inline-flex'}
      alignItems={'center'}
      justifyContent={'center'}
      transition={'background 0.3s ease'}
      _hover={{
        color: 'white',
        bg: useColorModeValue('brand.main'),
      }}>
      <VisuallyHidden>{label}</VisuallyHidden>
      {children}
  </chakra.button>
  );
};

export default function SocialButtons(props) {
  return (
    <Stack
      align={'center'}
      justify={'center'}
      direction={'row'}
      mt={6}
      pt={1}
      className={'social-buttons'}
    >
      {props.linkedin ? (
        <Link
          p={1}
          href={props.linkedin}
          isExternal
          className={'social-link'}
        >
          <SocialButton label={'Linkedin'}>
              <FaLinkedin />
          </SocialButton>
        </Link>
      ) : null }
      {props.github ? (
        <Link
          p={1}
          href={props.github}
          isExternal
          className={'social-link'}
        >
          <SocialButton label={'Github'}>
              <FaGithub />
          </SocialButton>
        </Link>
      ) : null }
      {props.twitter ? (
        <Link
          p={1}
          href={props.twitter}
          isExternal
          className={'social-link'}
        >
          <SocialButton label={'Twitter'}>
              <FaTwitter />
          </SocialButton>
        </Link>
      ) : null }
      {props.link ? (
        <Link
          p={1}
          href={props.link}
          isExternal
          className={'social-link'}
        >
          <SocialButton label={'Link'}>
              <FaLink />
          </SocialButton>
        </Link>
      ) : null }
    </Stack>
  );
}